storefrontApp.service('checkoutService', ['$http', function ($http) {
    return {
        getCountries: function () {
            return $http.get('countries');
        }
    }
}]);
